export default __webpack_public_path__ + "static/media/querelle_side.9293eb4a.jpg";